/**
 * SwitchDevise — dropdown compact pour choisir la devise affichée.
 * Persistance via localStorage (gérée dans useDevise).
 */
import { useEffect, useRef, useState } from "react";
import { colors, fonts } from "../styles/tokens";
import { TARIFS, DEVISES_LIST } from "../config/devises";
import useDevise from "../hooks/useDevise";

export default function SwitchDevise({ compact = false }) {
  const { devise, drapeau, changerDevise } = useDevise();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-block", fontFamily: fonts.body }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: compact ? "6px 10px" : "8px 14px",
          background: open ? colors.goldDim : colors.card,
          color: colors.text,
          border: `1px solid ${open ? colors.goldBorder : colors.border}`,
          borderRadius: 999,
          fontSize: compact ? 12 : 13,
          fontWeight: 600,
          cursor: "pointer",
          whiteSpace: "nowrap",
          transition: "all 150ms",
        }}
      >
        <span style={{ fontSize: 14 }}>{drapeau}</span>
        <span>{devise}</span>
        <span style={{ color: colors.textMuted, fontSize: 10 }}>▾</span>
      </button>

      {open && (
        <div
          role="listbox"
          style={{
            position: "absolute",
            top: "calc(100% + 6px)",
            right: 0,
            minWidth: 200,
            background: colors.card,
            border: `1px solid ${colors.border}`,
            borderRadius: 10,
            boxShadow: "0 15px 40px rgba(0,0,0,0.55)",
            zIndex: 200,
            overflow: "hidden",
            padding: 4,
          }}
        >
          {DEVISES_LIST.map((d) => {
            const t = TARIFS[d];
            const active = d === devise;
            return (
              <button
                key={d}
                type="button"
                onClick={() => { changerDevise(d); setOpen(false); }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  gap: 10,
                  padding: "8px 10px",
                  background: active ? colors.goldDim : "transparent",
                  color: active ? colors.gold : colors.text,
                  border: "none",
                  borderRadius: 8,
                  cursor: "pointer",
                  fontSize: 13,
                  fontWeight: active ? 600 : 500,
                  textAlign: "left",
                  transition: "background 120ms",
                }}
                onMouseEnter={(e) => { if (!active) e.currentTarget.style.background = colors.surface; }}
                onMouseLeave={(e) => { if (!active) e.currentTarget.style.background = "transparent"; }}
              >
                <span style={{ fontSize: 16 }}>{t.drapeau}</span>
                <span style={{ flex: 1 }}>{t.nom}</span>
                <span style={{ fontSize: 11, color: colors.textMuted, fontWeight: 600 }}>{t.code}</span>
                {active && <span style={{ color: colors.gold }}>✓</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
